/**
 * Re-export of the shared Testimonials component for the storefront renderer.
 * The base component (render + fields + defaults) lives in
 * `@launchstore/shared-puck`. The renderer uses it as-is — no
 * editor-specific field widgets.
 *
 * See launchstore-shared/src/puck/components/homepage/Testimonials/ for source.
 */
import { Testimonials as SharedTestimonials } from '@launchstore/shared-puck';

export const Testimonials: any = SharedTestimonials;
export type { TestimonialsProps } from '@launchstore/shared-puck';
export default Testimonials;
